import * as actions from './actions'
import mutations from './mutations'
import * as getters from './getters'

const MonthlyStates = {
  namespaced: true,
  state: {
    businessesMonthlyStates: []
  },
  getters,
  mutations,
  actions
}

export default MonthlyStates